import React, { useState } from "react";
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import MenuItem from "./MenuItem";
import { Page, PageProps } from "./interfaces/Page";
import Button from "../primitives/Button";
import MenuItemMobile from "./MenuItemMobile";
import Container from "../Common/Container";

const NavbarV1 = ({ pages = [], logo, buttons, className }: PageProps) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="bg-white">
      <div style={{ height: "72px" }}></div>
      <header className={`fixed inset-x-0 top-0 z-50 bg-white ${className}`}>
        <Container>
          <nav
            className="flex items-center justify-between lg:px-8 "
            aria-label="Global"
          >
            <div className="flex mr-6">
              <a href="/" className="-m-1.5 p-1.5">
                <span className="sr-only">Company</span>
                <img className="h-12 w-auto my-3" src={logo} alt="" />
              </a>
            </div>
            <div className="flex lg:hidden">
              <button
                type="button"
                className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                onClick={() => setMobileMenuOpen(true)}
              >
                <span className="sr-only">Open main menu</span>
                <Bars3Icon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="hidden lg:flex lg:gap-x-12">
              {pages.map((item: Page) =>
                item?.sublinks?.length || 0 > 0 ? (
                  <MenuItem
                    pages={item.sublinks}
                    key={item.id}
                    name={item.name}
                  />
                ) : (
                  <a
                    key={item.name}
                    href={item.path}
                    className={`text-sm font-semibold leading-6 hover:text-[--primary600]`}
                  >
                    {item.name}
                  </a>
                )
              )}
            </div>
            <div className="hidden lg:flex lg:flex-1 lg:justify-end">
              {buttons?.map((btn, idx) => (
                <Button {...btn} key={idx} className="block" />
              ))}
            </div>
          </nav>
        </Container>

        <Dialog
          as="div"
          className="lg:hidden"
          open={mobileMenuOpen}
          onClose={setMobileMenuOpen}
        >
          <div className="fixed inset-0 z-50" />
          <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <a href="/" className="-m-1.5 p-1.5">
                <img className="h-10 w-auto" src={logo} alt="" />
              </a>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                  {pages.map((item: any) =>
                    item?.sublinks?.length || 0 > 0 ? (
                      <MenuItemMobile
                        pages={item.sublinks}
                        key={item.id}
                        name={item.name}
                      />
                    ) : (
                      <a
                        key={item.name}
                        href={item.path}
                        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-[--primary100] cursor-pointer"
                      >
                        {item.name}
                      </a>
                    )
                  )}
                </div>
                <div className="py-6">
                  {buttons?.map((btn, idx) => (
                    <Button {...btn} key={idx} className="block" />
                  ))}
                </div>
              </div>
            </div>
          </Dialog.Panel>
        </Dialog>
      </header>
    </div>
  );
};

export default NavbarV1;
